<ng-container>
  <div class="activeDrafts" *ngIf="shouldShow()">
    <div class="body">
      <div class="title" *ngIf="!isMobile">Active Drafts</div>
      <div class="back" *ngIf="showBack()" (click)="back()"><i class="fas fa-chevron-left"></i></div>
      <ng-container *ngFor="let league of activeDrafts">
        <a [routerLink]="'/draft/'+league.league_id" class="league"
          [ngClass]="{'active':router.url.indexOf('/draft/'+league.league_id) > -1, 'pick':isMyPick(league)}"
          matTooltipPosition="below" [matTooltip]="league.league_name">
          <img [src]="darkMode?league.imgUrl.replace('.png','-dark.png'):league.imgUrl" [alt]="league.league_type.toUpperCase()" class="icon"> {{ (league.pick_time >= 600) ?
          "Slow:":""}}
          <span class="text"
            [ngClass]="{'warning':isMyPick(league) && league.time_left < 25 && league.time_left > 10, 'danger': isMyPick(league) && league.time_left <= 10}">{{ showMessage(league)}}</span>
          <div class="timer" *ngIf="isMyPick(league)"
            [ngClass]="{'warning':league.time_left < 25 && league.time_left > 10, 'danger': league.time_left <= 10}"
            [ngStyle]="{'width':league.width}"></div>
        </a>
        <div class="separator"></div>
      </ng-container>
    </div>
  </div>
</ng-container>